import { render, staticRenderFns } from "./FacebookPagePostCard.vue?vue&type=template&id=f51bd932"
import script from "./FacebookPagePostCard.vue?vue&type=script&lang=js"
export * from "./FacebookPagePostCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports